export enum SizingLevel {
  EXTRA_SMALL = 'xs',
  SMALL = 'sm',
  MEDIUM = 'md',
  LARGE = 'lg',
  EXTRA_LARGE = 'xl',
}

export interface SizingScale {
  level: SizingLevel;
  multiplier: number;
  label: string;
}

export const SIZING_SCALES: Record<SizingLevel, SizingScale> = {
  [SizingLevel.EXTRA_SMALL]: {
    level: SizingLevel.EXTRA_SMALL,
    multiplier: 0.85,
    label: 'Extra Small',
  },
  [SizingLevel.SMALL]: {
    level: SizingLevel.SMALL,
    multiplier: 0.925,
    label: 'Small',
  },
  [SizingLevel.MEDIUM]: {
    level: SizingLevel.MEDIUM,
    multiplier: 1.0,
    label: 'Medium',
  },
  [SizingLevel.LARGE]: {
    level: SizingLevel.LARGE,
    multiplier: 1.1,
    label: 'Large',
  },
  [SizingLevel.EXTRA_LARGE]: {
    level: SizingLevel.EXTRA_LARGE,
    multiplier: 1.2,
    label: 'Extra Large',
  },
} as const;

export const DEFAULT_SIZING_LEVEL = SizingLevel.MEDIUM;
